export function CodenameAttribution() {
  return (
    <a
      className="codename-attribution"
      href="https://codename.au/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Produced by Codename"
    >
      <span>Produced by</span>
      <img src="/images/codename-logo-acid-dark.svg" alt="Codename" width={532} height={73} />
    </a>
  );
}
